import React from 'react';

import { clsx } from 'js/app/utils/clsx.util';
import { SvgIcon } from 'js/app/components/common/SvgIcon';

import style from './index.scss';

export default ({
    className = '',
    isVisible,
    onClick,
    ...props // data attributes
}) => (
    <>
        <SvgIcon
            className={clsx(style.formIcon, style.showIcon, className, { hidden: isVisible })}
            type='show'
            disabled={!isVisible}
            onClick={onClick}
            {...props}
        />
        <SvgIcon
            className={clsx(style.formIcon, style.hideIcon, className, { hidden: !isVisible })}
            type='hide'
            disabled={!isVisible}
            onClick={onClick}
            {...props}
        />
    </>
);
